import { render, staticRenderFns } from "./SimulatorTallyButton.vue?vue&type=template&id=75fc1328&"
import script from "./SimulatorTallyButton.vue?vue&type=script&lang=js&"
export * from "./SimulatorTallyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports